<!-- Details Header -->
<mat-toolbar>
  <span role="heading" class="mat-title">Details</span>
</mat-toolbar>
<section id="details-area">
  <!-- Steps List-->
  <ng-content select="app-subtasks" id="steps-area"></ng-content>
  <!-- Details Area -->
  <mat-tab-group>
    <mat-tab label="Form">
      <form id="task-details-form" [formGroup]="form">
        <!-- Title and Notes -->
        <mat-card id="text-fields-area">
          <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput name="title" id="title-field" required formControlName="title" (blur)="onBlur()">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Notes</mat-label>
            <textarea matInput name="notes" id="notes-field" rows="6" formControlName="notes" (blur)="onBlur()"></textarea>
          </mat-form-field>
          <mat-checkbox formControlName="deleted">Deleted</mat-checkbox>
        </mat-card>
        <!-- Status Fields -->
        <mat-card id="status-fields-area">
          <mat-form-field appearance="outline">
            <mat-label>Deadline</mat-label>
            <input matInput type="date" name="due-date" id="due-date-field" formControlName="due" (blur)="onBlur()">
          </mat-form-field>
          <mat-form-field appearance="outline" formGroupName="updated">
            <mat-label>Updated</mat-label>
            <input readonly matInput type="date" name="updated-date" id="updated-date-field" formControlName="date">
            <input readonly matInput type="time" name="updated-time" id="updated-time-field" formControlName="time">
          </mat-form-field>
          <mat-form-field appearance="outline" formGroupName="completed">
            <mat-label>Completed</mat-label>
            <input readonly matInput type="date" name="completed-date" id="completed-date-field" formControlName="date">
            <input readonly matInput type="time" name="completed-time" id="completed-time-field" formControlName="time">
          </mat-form-field>
        </mat-card>
      </form>
    </mat-tab>
    <mat-tab label="Raw">
      <mat-card id="raw">
        <mat-card-content>
          <pre>{{fullTask | json}}</pre>
        </mat-card-content>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</section>
